// extracted by mini-css-extract-plugin
export default {"registerContainer":"Register_registerContainer__bktTN"};